var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnPlaces(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6797 2.75C15.6797 1.55469 16.7344 0.5 17.9297 0.5C19.1953 0.5 20.25 1.55469 20.25 2.75H31.0078C31.2891 2.75 31.5703 2.89062 31.7812 3.10156L35.1562 6.47656C35.5781 6.89844 35.5781 7.67188 35.1562 8.09375L31.7812 11.4688C31.5703 11.6797 31.2891 11.75 31.0078 11.75H4.42969C3.23438 11.75 2.17969 10.7656 2.17969 9.5V5C2.17969 3.80469 3.23438 2.75 4.42969 2.75H15.6797ZM33.75 23C33.75 24.2656 32.6953 25.25 31.5 25.25H4.92188C4.64062 25.25 4.35938 25.1797 4.14844 24.9688L0.773438 21.5938C0.351562 21.1719 0.351562 20.3984 0.773438 19.9766L4.14844 16.6016C4.35938 16.3906 4.64062 16.25 4.92188 16.25H15.6797V14H20.25V16.25H31.5C32.6953 16.25 33.75 17.3047 33.75 18.5V23ZM17.9297 36.5C16.7344 36.5 15.6797 35.5156 15.6797 34.25V27.5H20.25V34.25C20.25 35.5156 19.1953 36.5 17.9297 36.5Z",
    fill: "#476930"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnPlaces);
export default __webpack_public_path__ + "static/media/btnPlaces.835bbcc08b2581576e828d2c5314b748.svg";
export { ForwardRef as ReactComponent };